import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getAllSettingDesign } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import FormTarahi from "./components/FormTarahi/FormTarahi";
import Translator from "Languages/Utility/Translator";

function TarahiSettings() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllSettingDesign(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-4">
        <PageTitle title={<Translator id={"designSettings"} />} />
      </div>
      <MuiPaper>
        <FormTarahi />
      </MuiPaper>
    </Fragment>
  );
}

export default TarahiSettings;
